import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FadeInOnScrollDirective } from '../../../directives/fade-in-on-scroll.directive';

@Component({
  selector: 'app-what-is-szebit',
  templateUrl: './what-is-szebit.component.html',
  styleUrl: './what-is-szebit.component.scss',
  imports: [FadeInOnScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatIsSzebitComponent {}
